import React from "react";
import "../assets/style.css";

const WhatWeDo: React.FC = () => {
  return (
    <section className="what-we-do bg-gradiant financial-p5">
      <div className="container">
        <div className="row title-bar">
          <div className="col-md-12">
            <h1 className="wow fadeInUp cl-white">Global Business Services</h1>
            <div className="heading-border bg-white"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              {services.map((service, index) => (
                <div key={index} className="col-md-4 col-sm-6">
                  <div
                    className="what-we-desc wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    <i className={`fa ${service.icon}`}></i>
                    <h6>{service.title}</h6>
                    <p className="desc">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const services = [
  {
    title: "Professional Growth",
    icon: "fa-bar-chart",
    description:
      "It is achieved through continuous learning, practical experience, and the right guidance. At LyraZone, we support individuals and teams in developing valuable skills, improving performance, and adapting to changing industry demands. Our approach encourages confidence, innovation, and career advancement for long-term success in a competitive professional environment.",
  },
  {
    title: "Research & Development",
    icon: "fa-bullseye",
    description:
      "It drives innovation by turning ideas into practical solutions. At LyraZone, we focus on exploring new technologies, improving existing systems, and developing smarter approaches that meet evolving business needs. Our commitment to research and continuous improvement helps create efficient, reliable, and forward-thinking solutions for sustainable growth and long-term success.",
  },
  {
    title: "Valuable Services",
    icon: "fa-star-o",
    description:
      "Valuable Services are at the heart of LyraZone’s commitment to quality, reliability, and customer success. We provide practical technology solutions designed to meet business needs, improve efficiency, and support growth. By combining expertise, innovation, and dedicated support, our services create real value and lasting impact for every client we serve.",
  },
];

export default WhatWeDo;
